import { z } from "zod";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";

/** The deliberately small attachment shape needed by the history view. */
const MessageHistoryAttachmentJSONZ = z.union([
  z.string(),
  z.object({ name: z.string().nullish() }).passthrough(),
]);

export default class MessageHistorySchema {
  public static readonly MessageHistoryAttachmentJSONZ = MessageHistoryAttachmentJSONZ;
  public static readonly MessageHistoryJSONZ = z.object({
    id: z.uuid(),
    content: z.string().nullish(),
    subject: z.string().nullish(),
    created: z.iso.datetime({ offset: true }),
    updated: z.iso.datetime({ offset: true }).nullish(),
    attachments: z.array(MessageHistoryAttachmentJSONZ).nullish(),
    attachmentCount: z.number().nullish(),
  });

  public static validateJSON(json: unknown): MessageHistoryJSON {
    return parseOrThrow(MessageHistorySchema.MessageHistoryJSONZ, json, {
      logError: true,
      schemaName: "MessageHistorySchema",
      operation: "validateJSON",
      payloadSample: json,
    });
  }
}

export type MessageHistoryJSON = z.infer<typeof MessageHistorySchema.MessageHistoryJSONZ>;
